import axios from '@/api/axios';

export const getSportLiveTvCategories = async (offset, limit) => {
  const { data } = await axios.get('/api/info/sport-livetv/categories', { params: { offset, limit } });

  return data.data;
};

export const getSportLiveTvCategoryEvents = async (categoryId, offset, limit) => {
  const { data } = await axios.get(`/api/info/sport-livetv/categories/${categoryId}/events`, { params: { offset, limit } });

  return data.data;
};

export const getPopularSportLiveTvEvents = async (offset, limit) => {
  const { data } = await axios.get(`/api/popular/sport-livetv-event/${offset}/${limit}`);

  return data.data;
};

export const getSportLiveTvTeams = async (offset, limit) => {
  const { data } = await axios.get('/api/info/sport-livetv/teams', { params: { offset, limit } });

  return data.data;
};

export const searchSportLiveTvEvents = async (keyword, limit) => {
  const { data } = await axios.get(`/api/info/sport-livetv-event/search/${encodeURIComponent(keyword)}/${limit}`);

  return data.data;
};

export const updateSportLiveTvPosition = (eventId, seconds) => axios.put(`/api/history/sport-livetv/position/${eventId}`, { position: seconds });

export const getSportLiveTvStreamLink = async (epgId) => {
  const { data } = await axios.get(`/api/play/livetv.epg/${epgId}.m3u8`);

  return data.data.secure_link;
};
